import Button from 'common/components/Elements/Button/Button';
import useShortcut from 'common/utilities/hooks/useShortcut/useShortcut';
import classes from 'core/components/Elements/Command/Command.style';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import type { EnhancedCommand } from 'core/utilities/core.types';
import React, { useEffect } from 'react';

export interface ComponentProps {
  command: EnhancedCommand;
  small?: boolean;
}

function CommandOnClick({ command, small }: ComponentProps) {
  const {
    id, title, active, label, shortcut, action, inheritColor,
  } = command;

  const shortcutTrigger = useShortcut(...(shortcut || []));

  useEffect(() => {
    if (command.onClick && active && shortcut && shortcutTrigger) {
      command.onClick(command);
    }
  }, [shortcut, shortcutTrigger, active, command]);

  return (
    <Button
      action={action || 'tertiary'}
      className={classes.command}
      title={title}
      onClick={() => { if (command.onClick) command.onClick(command); }}
      small={small}
      disabled={active === false}
      e2eId={id}
      buttonIcon={label === undefined}
      inheritColor={inheritColor}
    >
      <CommandLinkContent command={command} />
    </Button>
  );
}

export default CommandOnClick;
